import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=e5639b48"
import script from "./preview-video.vue?vue&type=script&lang=js"
export * from "./preview-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5639b48')) {
      api.createRecord('e5639b48', component.options)
    } else {
      api.reload('e5639b48', component.options)
    }
    module.hot.accept("./preview-video.vue?vue&type=template&id=e5639b48", function () {
      api.rerender('e5639b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/preview-video.vue"
export default component.exports